"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumMapper = void 0;
var EnumMapper = /** @class */ (function () {
    function EnumMapper(entities) {
        var _this = this;
        this.vodToGqlMap = new Map(entities);
        this.gqlToVodMap = new Map();
        this.vodToGqlMap.forEach(function (gqlEntity, vodEntity) {
            return _this.gqlToVodMap.set(gqlEntity, vodEntity);
        });
    }
    EnumMapper.prototype.toVod = function (entity) {
        return this.gqlToVodMap.get(entity);
    };
    EnumMapper.prototype.toGql = function (entity) {
        return this.vodToGqlMap.get(entity);
    };
    return EnumMapper;
}());
exports.EnumMapper = EnumMapper;
//# sourceMappingURL=enum-mapper.js.map